module.exports = __webpack_public_path__ + "img/fgh_ev.4b3809c7.jpg";